import { useMemo } from "react";
import { useIntl } from "react-intl";

export type PeriodType = "MONTHLY" | "QUARTERLY" | "YEARLY";

export const useXAxisLabels = (period: PeriodType) => {
  const intl = useIntl();

  return useMemo(() => {
    const getMessage = (id: string, defaultMessage: string) =>
      intl.formatMessage({ id, defaultMessage });

    const monthly = [
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/January",
        "Jan"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/February",
        "Feb"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/March",
        "Mar"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/April",
        "Apr"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/May",
        "May"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/June",
        "Jun"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/July",
        "Jul"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/August",
        "Aug"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/September",
        "Sep"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/October",
        "Oct"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/November",
        "Nov"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/December",
        "Dec"
      ),
    ];

    const quarterly = [
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q1",
        "Q1"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q2",
        "Q2"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q3",
        "Q3"
      ),
      getMessage(
        "components/pages:SalesDashBoard/lineChartEmission/XAxis/Q4",
        "Q4"
      ),
    ];

    return period === "QUARTERLY" ? quarterly : monthly;
  }, [intl, period]);
};
